import type { KdsTicket } from "@/types/kds";

interface KdsTotalizerProps {
  tickets: KdsTicket[];
}

export function KdsTotalizer({ tickets }: KdsTotalizerProps) {
  // Aggregate pending items (not done)
  const itemCounts = new Map<string, number>();
  for (const ticket of tickets) {
    for (const item of ticket.items) {
      if (item.status === "done") continue;
      const key = item.name_snapshot;
      itemCounts.set(key, (itemCounts.get(key) || 0) + item.quantity);
    }
  }

  const sorted = [...itemCounts.entries()].sort((a, b) => b[1] - a[1]);

  if (sorted.length === 0) return null;

  return (
    <div className="w-56 shrink-0 bg-zinc-800/60 border-l border-zinc-700 overflow-y-auto">
      <div className="px-3 py-3 border-b border-zinc-700">
        <h2 className="text-sm font-semibold text-zinc-300 uppercase tracking-wide">Totalizador</h2>
      </div>
      <div className="p-2 space-y-0.5">
        {sorted.map(([name, qty]) => (
          <div key={name} className="flex items-center justify-between px-2 py-1.5 rounded hover:bg-zinc-700/50">
            <span className="text-sm text-zinc-300 truncate flex-1">{name}</span>
            <span className="text-sm font-bold text-white ml-2">{qty}x</span>
          </div>
        ))}
      </div>
    </div>
  );
}
